import { useState } from 'react';
import { useAuthStore } from 'src/hooks/auth';
import { useFormStore } from 'src/hooks/form';
import { AddFormResponseApiPayload } from 'src/api';
import { logger } from 'src/services/logger';
import { CommonFormProps } from '.';
import { useBeforeUnload } from '@insight-health-ai/roseate/utils';

// forms
import { ReviewOfSystems } from './reviewOfSystems';
import { PFDI } from './PFDI';
import { LapPDVideoNorthwest } from './lapPDVideoNorthwest';
import { OOS } from './OOS';
import { TOCNeuro } from './TOCNeuro';
import { BANG } from './BANG';
import { DVPRS } from './DVPRS';
import { PROMIS } from './PROMIS';
import { SOAPP2Form } from './SOAPP2';
import { PainManagementForm } from './painManagement';
import { Medications } from './medications';
import { DACForm } from './DAC';
// styles for backward compatibility
import 'src/styles/app.scss';
import { PHQ9Form } from './PHQ9';

export const Forms = () => {
  const { activeForm, saveForm, reviewDetails } = useFormStore();
  const { appointment } = useAuthStore();
  const [loading, setLoading] = useState(false);

  const formType = activeForm?.form_type || '';
  /**
   * Prompt user to save the chat before leaving the page
   */

  useBeforeUnload({ enabled: !!activeForm });

  const onSaveForm = (payload: AddFormResponseApiPayload) => {
    setLoading(true);
    return saveForm(payload)
      .catch((error) => {
        logger.error(
          'Forms: failed to save form',
          {
            formType,
          },
          error
        );
        throw error;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const commonProps: CommonFormProps = {
    loading,
    form: activeForm!,
    isOpen: true,
    onSave: onSaveForm,
    appointment: appointment!,
  };

  if (formType === 'Review_of_Systems') {
    return <ReviewOfSystems {...commonProps} />;
  } else if (formType === 'PFDI_Form') {
    return <PFDI {...commonProps} />;
  } else if (
    [
      'lap_PD_catheter_video_northwest_mis',
      'lap_cholecystectomy_video_northwest_mis',
    ].includes(formType)
  ) {
    return <LapPDVideoNorthwest {...commonProps} />;
  } else if (['KOOS', 'HOOS'].includes(formType)) {
    return <OOS {...commonProps} />;
  } else if (formType === 'TOC_Neuro') {
    return <TOCNeuro {...commonProps} />;
  } else if (formType === 'Obstructive_Sleep_Apnea') {
    return <BANG {...commonProps} />;
  } else if (formType === 'DVPRS') {
    return <DVPRS {...commonProps} />;
  } else if (formType === 'PROMIS') {
    return <PROMIS {...commonProps} />;
  } else if (formType === 'NDI/ODI') {
    return <PainManagementForm {...commonProps} />;
  } else if (formType === 'DAC') {
    return <DACForm {...commonProps} />;
  } else if (formType === 'SOAPP2') {
    return <SOAPP2Form {...commonProps} />;
  } else if (formType === 'PHQ9') {
    return <PHQ9Form {...commonProps} />;
  }

  if (reviewDetails) {
    return <Medications isOpen />;
  }

  return null;
};
